import React from "react";
import "../../styles/vars.scss";
import "../../styles/main.scss";
import "../../styles/compo.scss";
import SvgIcn from "../../data/IconCompo";

function TopCardP({
  icon,
  title,
  text,
  to,
  children,
  clickable,
  color,
  className,
  onClick,
}) {
  const cardClass = `top-card ${clickable ? "clickable" : ""} ${
    color || "g_04"
  } ${className || ""}`;

  return (
    <div
      className={cardClass}
      onClick={() => {
        if (clickable) {
          onClick();
        }
      }}
    >
      {icon && <SvgIcn name={icon} className="card-icon" />}
      <h2>{title}</h2>
      {text && <p dangerouslySetInnerHTML={{ __html: text }} />}
      {children}
    </div>
  );
}

export default TopCardP;
